import { EncryptStorage } from 'encrypt-storage'

// 暗号化定義
export const encryptStorage: Storage = <Storage>new EncryptStorage('spits-store', {
  // 保存するストレージを指定
  storageType: 'sessionStorage',
  // 永続化パッケージで状態管理できるようにする(Piniaでは必須)
  stateManagementUse: true
})
